import { DataScienceCourse } from './types';
import { ADVANCED_STATS_MODULE, ML_PIPELINE_MODULE } from './modules/intermediate';

export const DATASCIENCE_INTERMEDIATE_COURSE: DataScienceCourse = {
  id: 'datascience-intermediate',
  title: 'Intermediate Data Science',
  description: 'Advance your data science skills with machine learning pipelines, advanced analytics, and big data tools. Build production-ready solutions.',
  level: 'intermediate',
  totalDuration: '16-20 hours',
  image: '/api/placeholder/400/300',
  prerequisites: [
    'Completed Data Science Fundamentals course',
    'Comfortable with Python programming',
    'Understanding of basic statistics',
    'Experience with Pandas and NumPy'
  ],
  learningOutcomes: [
    'Build end-to-end machine learning pipelines',
    'Perform advanced statistical analysis and A/B testing',
    'Create interactive dashboards and visualizations',
    'Handle time series data and forecasting',
    'Work with big data tools and frameworks',
    'Implement feature engineering techniques',
    'Design and analyze experiments',
    'Deploy models for business applications'
  ],
  modules: [ADVANCED_STATS_MODULE, ML_PIPELINE_MODULE]
};
